module.exports = __webpack_public_path__ + "img/pimg10.9135cca4.png";